var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34314 1.34314 0 3 0H19C20.6569 0 22 1.34314 22 3V18H4C3.44771 18 3 18.4478 3 19V20C3 20.5522 3.44771 21 4 21H20.5C21.3284 21 22 21.6716 22 22.5C22 23.3284 21.3284 24 20.5 24H3C1.34314 24 0 22.6569 0 21V3ZM19 3H14V11L16.5 9L19 11V3Z",
    fill: "#121258"
  })));
}

export default SvgHc;